<template>
    <!-- 体操 -->
    <div class="gyms-list">    
        <div class="title">
            <div  v-for="(item,index) in gameScoreData" :key="index" :class="item.scores?'active':'active-one'">
                <span>{{refereeNumObj[item.refereeNum] ? refereeNumObj[item.refereeNum] : item.refereeNum + '裁判'}}</span>
            </div>
        </div>
        <div class="box">
             <div class="column" v-for="(item,index) in gameScoreData" :key="index" >
                <template v-if="item.scores">
                    <template v-for="(value,j) in item.scores" >
                        <div class="row"  :key="j" v-if="j!='refereeNum'" :class="j%2==1?'active':''">{{value.scoreKey}}  {{drefreeList.indexOf(item.refereeNum)==-1?'-':'+'}}{{value.scoreValue?value.scoreValue:'0.0'}}</div> 
                    </template>
                </template>
                <template v-else>
                    <div class="row-one"  :key="index" v-if="index!='refereeNum'" >{{drefreeList.indexOf(item.refereeNum)==-1?'-':'+'}}{{item.score}}</div> 
                </template>
            </div>
        </div>      
        <div class="score">
             <div class="active" v-for="(item,index) in gameScoreData" :key="index" >
                <template v-if="item.scores">
                    <span>艺术错误：</span>-{{item.totalScore}}
                </template>
            </div>
        </div>
       
    </div>
</template>

<script>
const refereeNumObj={
  'JD':'监督裁判',
  'SL':'左视线裁判',
  'SR':'右视线裁判',
  'T': '计时裁判'
}
const ScoreType={
  actionScore :'动作特征',
  stepScore : '舞步组合',
  bodyScore : '身体和面部表现力',
  powerScore : '动力性变化',
  apparatusScore : '身体/器械与音乐效果',
  diversityScore : '多样性',
  fieldScore : '场地的使用',
  unityScore : '统一性',
  joinScore: '连接',
  rhythmScore : '节奏',
  musicScore : '音乐',
  standardScore: '音乐规范',
  preludeScore : '超过四秒的音乐前奏'
}
export default {
  name:'GymsList',
  props:['gameScoreData'],
  data () {
    return {
      refereeNumObj,
      ScoreType,
      drefreeList:['05','06','07','08','D1','D2','D3','D4']
    }
  },
  mounted () {
    console.log('gameScoreData',this.gameScoreData)

  },
}
</script>

<style lang="scss" scoped>
  .gyms-list{
    padding-left:30px;

    //标题
    .title{
        width: 100%;
        text-align: left;
        line-height: 30px;
        height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .active{
            background-color: #EFEFEF;
            width:50%;
            padding-left:15px;
            font-weight: bold;
        }
        .active-one{
            background-color: #EFEFEF;
            width:100%;
            padding-left:15px;
            font-weight: bold;
        }
    }
    // 详情数据
    .box{
        display: flex; 
        flex-direction: row;
        justify-content: space-evenly;
        box-sizing: border-box;
        height: 300px;
        overflow: auto;
        .column{
            width: 100%;
            text-align: left;
            max-height: 320px;
            .row{
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
                overflow: auto;         
            }
            .active{
                background-color: #EFEFEF;
            }
            .row-one{
                width: 100%;
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
            }
           
        }
         
        
    }
    //总分
    .score{
        width: 100%;
        text-align: left;
        line-height: 30px;
        height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .active{
            width:50%;
            padding-left:15px;
            font-weight: bold;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/gyms/GymsList.vue